import React from "react"
import Parser, { attributesToProps, domToReact } from 'html-react-parser';
import { unSlash } from './unSlash'
import { Link } from "react-router-dom";

const Videos = React.lazy(() => import('../Blocks/Videos'));
const Playlists = React.lazy(() => import('../Blocks/Playlists'));
const Carousel = React.lazy(() => import('../Blocks/Carousel'));
const Product = React.lazy(() => import('../Blocks/Product'));
const Filters = React.lazy(() => import('../Blocks/Filters'));
const Search = React.lazy(() => import('../Blocks/Search'));

const options = {
	trim: true,
	replace: (domNode) => {
		const props = attributesToProps(domNode.attribs);
		if(props.className) {
			const classes = props.className.split(" ");
			const blockClass = classes.flatMap((str, i) => str.includes('block-') ? str : []);
			if(blockClass.length) return parseBlocks(domNode, props, blockClass);
		}
		switch(domNode.name) {
			case 'a':
				if( domNode.attribs.href && ( domNode.attribs.href.startsWith('/') ||  domNode.attribs.href.startsWith(global.config.baseURL) ) ) {
					let path = unSlash( domNode.attribs.href.replace(global.config.baseURL, '') );
					return <Link to={path} className={domNode.attribs.class} style={domNode.attribs.style}>{domToReact(domNode.children)}</Link>
				}
				break;
			case 'select':
				return <select {...props} onChange={(ev)=> { console.log(ev.target.value); }}>{domToReact( domNode.children, options ) }</select>
			case 'input':
				switch(domNode.attribs.type) {
					case 'hidden':
						return  <input 
							type={domNode.attribs.type} 
							name={domNode.attribs.name} 
							value={domNode.attribs.value} 
							id={domNode.attribs.id} 
							className={domNode.attribs.class} 
							/>;
					case 'color': 
					case 'date': 
					case 'month': 
					case 'week': 
					case 'datetime-local': 
						break;
					case 'radio':
					case 'checkbox':
						let isChecked = ( typeof( domNode.attribs.checked ) === 'string' ) ? 'checked' : false
						return  <input 
							type={domNode.attribs.type} 
							name={domNode.attribs.name} 
							value={domNode.attribs.value} 
							id={domNode.attribs.id} 
							defaultChecked={isChecked} 
							className={domNode.attribs.class} 
							disabled={domNode.attribs.disabled} 
							/>;
					case 'button':
					case 'submit':
					case 'reset':
						break;	
					default: 
						return  <input 
							type={domNode.attribs.type} 
							name={domNode.attribs.name} 
							defaultValue={domNode.attribs.value} 
							placeholder={domNode.attribs.placeholder} 
							id={domNode.attribs.id} 
							className={domNode.attribs.class} 
							disabled={domNode.attribs.disabled} 
							/>;
				}
				break;
			default:
				return domNode;
		}
	}
}

function parseBlocks(domNode, props, blockClass) {
	//console.log('parseBlocks',domNode, props, blockClass)
	switch(true) {
		case blockClass.includes("block-Videos"): 
			return <Videos {...props}>{domToReact( domNode.children, options ) }</Videos>
		case blockClass.includes("block-Playlists"): 
			return <Playlists {...props}>{domToReact( domNode.children, options ) }</Playlists>
		case blockClass.includes("block-Carousel"): 
			return <Carousel {...props}>{domToReact( domNode.children, options ) }</Carousel>
		case blockClass.includes("block-Product"): 
			return <Product {...props}>{domNode.children}</Product>
		case blockClass.includes("block-VideoFilters"): 
			return <Filters {...props}>{domToReact( domNode.children, options ) }</Filters>
		case blockClass.includes("block-VideoSearch"): 
			return <Search {...props}>{domToReact( domNode.children, options ) }</Search>
		case blockClass.includes("block-PlaylistFilters"): 
			return <Filters {...props}>{domToReact( domNode.children, options ) }</Filters>
		case blockClass.includes("block-PlaylistSearch"): 
			return <Search {...props}>{domToReact( domNode.children, options ) }</Search>
		default:
			return domNode;
	}
}

export function ParseHtml(data) {
	const output = Parser( data, options );
	return output;
}